export const WER_CALCULATION_SECTION = 'how-is-this-calculated'
